import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import type { ChartOptions } from "chart.js";
import { Col, Row } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import type { PkHc } from "../../../types/playerPk";
import "./pk.css";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const options: ChartOptions<"bar"> = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: {
      title: {
        display: true,
        text: "Victim level",
        color: "rgb(199, 238, 255)"
      },
      ticks: { color: "rgb(199, 238, 255)" },
      grid: { color: "rgb(70, 130, 180)" }
    },
    y: {
      beginAtZero: true,
      ticks: { color: "rgb(199, 238, 255)", precision: 0 },
      grid: { color: "rgb(70, 130, 180)" }
    }
  },
  plugins: { legend: { display: false } }
};

type Props = {
  hc: PkHc;
};

const HcSection = ({ hc }: Props) => (
  <Row className="g-3">
    <Col xs={12}>
      <div className="pk-card">
        <div className="pk-subtitle">HC kills by level</div>
        <div className="pk-chart-box">
          <Bar
            options={options}
            data={{
              labels: hc.byLevel.map((b) => `${b.levelStart}-${b.levelEnd}`),
              datasets: [
                {
                  label: "HC kills",
                  data: hc.byLevel.map((b) => b.kills),
                  borderColor: "#e0b93d",
                  backgroundColor: "rgba(224, 185, 61, 0.7)"
                }
              ]
            }}
          />
        </div>
      </div>
    </Col>
  </Row>
);

export default HcSection;
